import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setOrderListModal } from '../actions/modalActions'
import * as dataActions from '../actions/modalActions'
import Modal from 'react-modal'
import * as properties from '../../constants/Properties'
import * as resource from '../../constants/Resources'
import { getTranslation } from '../../actions/dataActions'
import OrderLine from '../../components/OrderLine'

class OrderListModal extends Component {
    constructor(props) {
        super(props);
        this.cancelTap = this.cancelTap.bind(this);
        this.processTouchTap = this.processTouchTap.bind(this);
        this.processOrder = this.processOrder.bind(this);
        this.sortOrdersOnNumber = this.sortOrdersOnNumber.bind(this);
        this.sortOrdersOnDate = this.sortOrdersOnDate.bind(this);
        this.sortOrdersOnCustomer = this.sortOrdersOnCustomer.bind(this);
        this.sortOrdersOnUser = this.sortOrdersOnUser.bind(this);
        this.toggleShowToday = this.toggleShowToday.bind(this);
        this.state = {
            selectedOrder: null,
            orders: [],
            asc: true,
            showTodayOnly: true
        }
    }

    cancelTap() {
        this.setState({
            selectedOrder: null
        })
        this.props.setOrderListModal([], false, 'default');
    }


    processTouchTap(param) {
        if (param === this.state.selectedOrder) {
            param = null;
        }

        this.setState({
            selectedOrder: param
        });
    }

    processOrder() {
        const callback = this.props.orderListModal.callback;
        const dispatch = this.props.orderListModal.dispatch;

        const selectedOrder = this.state.selectedOrder;
        if(selectedOrder)
        {
            // Order is already payed at webshop, so no need to at these to receiptlines
            if(selectedOrder.PayedOnWebshop)
            {
                dispatch(dataActions.processPayedInWebshopOrder(this.state.selectedOrder.OrderNumber));
                this.setState({ selectedOrder: null });
                this.props.setOrderListModal([], false, 'default');
            }
            else    
            {
                let callbackParams = [this.state.selectedOrder];
                if (this.props.orderListModal.callbackparams !== undefined) {
                    this.props.orderListModal.callbackparams.map(param => {
                        callbackParams.push(param);
                        return '';
                    })
                }

                this.setState({ selectedOrder: null });
                this.props.setOrderListModal([], false, 'default');

                if (callback !== null) {
                    if (dispatch !== null) {
                        dispatch(callback.apply(this, callbackParams));
                    } else {
                        callback.apply(this, callbackParams);
                    }
                }
            }
        }
    }

    sortOrdersOnNumber() {
        var sort = this.state.asc;
        let newList = this.props.orderListModal.listvalues.sort(function (a, b) {
            return sort ? b.Order.OrderNumber - a.Order.OrderNumber : a.Order.OrderNumber - b.Order.OrderNumber;
        });

        this.setState(state => ({ orders: newList, asc: !state.asc }));
    }

    sortOrdersOnDate() {
        var sort = this.state.asc;
        let newList = this.props.orderListModal.listvalues.sort(function (a, b) {
            return sort ? b.Order.PickupDate - a.Order.PickupDate : a.Order.PickupDate - b.Order.PickupDate;
        });

        this.setState(state => ({ orders: newList, asc: !state.asc }));
    }

    sortOrdersOnCustomer() {
        var sort = this.state.asc;
        let newList = this.props.orderListModal.listvalues.sort(function (a, b) {
            return sort ? b.Order.CustomerName.localeCompare(a.Order.CustomerName) : a.Order.CustomerName.localeCompare(b.Order.CustomerName);
        });

        this.setState(state => ({ orders: newList, asc: !state.asc }));
    }

    sortOrdersOnUser() {
        var sort = this.state.asc;
        let newList = this.props.orderListModal.listvalues.sort(function (a, b) {
            return sort ? b.Order.SystemUserName.localeCompare(a.Order.SystemUserName) : a.Order.SystemUserName.localeCompare(b.Order.SystemUserName);
        });

        this.setState(state => ({ orders: newList, asc: !state.asc }));
    }

    toggleShowToday(){
        this.setState(state => ({
            showTodayOnly: !state.showTodayOnly
        }));
    }

    checkIfToday(orderDate){
        var today = new Date();
        var order = new Date(orderDate);

        var todayMonth = today.getMonth();
        var todayDay = today.getDate();
        var todayYear = today.getFullYear();

        var orderMonth = order.getMonth();
        var orderDay = order.getDate();
        var orderYear = order.getFullYear();

        return todayDay === orderDay &&
                 todayMonth === orderMonth &&
                 todayYear === orderYear;
    }

    render() {
        let newList = this.state.orders.length === 0 ? this.props.orderListModal.listvalues : this.state.orders;
        if (this.state.showTodayOnly) {
            newList = newList.filter(order => {
                return this.checkIfToday(order.Order.OrderDate);
            }); 
        }

        const toggleButtonTextToShow = this.state.showTodayOnly ? "Toon alles" : "Toon vandaag";

        return (
            <Modal className='orderListModal'
                contentLabel=""
                isOpen={this.props.orderListModal.show}
                style={properties.orderListModalStyle}
            >
                <div className="orderListModal_header">
                    <div className="header_top">
                        Orders
                    </div>
                </div>
                <div className="orderListModal_content">
                {
                    this.state.selectedOrder === null &&
                        <table className="topOrderTable">
                            <tr>
                                <th onClick={this.sortOrdersOnNumber}>
                                    Order
                                </th>
                                <th onClick={this.sortOrdersOnCustomer}>
                                    {this.props.getTranslation(resource.CUSTOMER)}
                                </th>
                                <th onClick={this.sortOrdersOnDate}>
                                    {this.props.getTranslation(resource.ORDER_DATE)}
                                </th>
                                <th onClick={this.sortOrdersOnUser}>
                                    {this.props.getTranslation(resource.OBJECT_ITEM_NUMBER)}
                                </th>
                            </tr>
                        </table>
                }
                {
                    newList.map(val =>
                        <OrderLine
                            key={val.Order.OrderNumber}
                            Order={val.Order}
                            CustomId={val.CustomerId}
                            OrderLines={val.Order.OrderLines}
                            Callback={this.processTouchTap}
                            show={this.state.selectedOrder != null ? (this.state.selectedOrder.OrderNumber === val.Order.OrderNumber ? true : false) : true}
                        />
                    )
                }
                </div>
                <div className="orderListModal_footer">
                    <button className="btnCancel" onClick={this.cancelTap} >
                        {this.props.getTranslation(resource.CANCEL)}
                    </button>
                    {
                        this.state.selectedOrder == null && 
                        <button className="btnToggle" onClick={this.toggleShowToday}>
                            {toggleButtonTextToShow}
                        </button>
                    }
                    {this.state.selectedOrder != null &&
                        <button className="btnOrder" onClick={this.processOrder} >
                            {this.props.getTranslation(this.state.selectedOrder.PayedOnWebshop ? resource.CLOSE_ORDER : resource.PAY_ORDER)} #{this.state.selectedOrder.OrderNumber}
                        </button>
                    }
                </div>

            </Modal>
        )
    }
}

OrderListModal.propTypes = {

}


function mapStateToProps(state) {
    return {
        orderListModal: state.modalState.orderListModal
    }
}

export default connect(mapStateToProps, {
    setOrderListModal,
    getTranslation
})(OrderListModal)



// WEBPACK FOOTER //
// src/modal/components/OrderListModal.jsx